// SpanishVocabTab.jsx
import React from 'react';
import { EnterOutlined } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import { Input as InputArea } from 'antd';
import { Add, Delete } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Loading from 'components/Loading';
import { get } from 'lodash';
import styled from 'styled-components';
import { dispalayRole } from 'utils/methods/math';

const SpanishVocabTab = ({
  vocabularyData,
  showWordLoader,
  callVocAI,
  handleAddVocData,
  editDataPropertyStd,
  handleUpdateData,
  addNewItem,
  setDeleteModal,
  setDeleteVocab,
  currentUser,
  from = {},
}) => {
  return (
    <StyledTable border className="vocabulTable">
      <StyledHeader className="vocabulHeadTh">
        <StyledTh style={{ minWidth: 150, maxWidth: 250 }}>Word</StyledTh>
        <StyledTh style={{ minWidth: 150 }}>English translation</StyledTh>
        <StyledTh>Definition</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Synonyms</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Antonyms</StyledTh>
        <StyledTh>Sentence in Spanish</StyledTh>
        <StyledTh>Actions</StyledTh>
      </StyledHeader>

      {vocabularyData.map((value, k) => {
        let data = get(value, 'data', '');
        const roleDisplay =
          from?.from === 'admin' && from?.page === 'edit-resource'
            ? `(${dispalayRole(value?.created_by)})`
            : from?.from === 'admin' && from?.page === 'inapporiate-word'
              ? `(Admin)`
              : ``;
        return (
          <tr className="vocabulHeadTr vocIcons" key={k}>
            <td style={{ minWidth: 150, maxWidth: 250 }}>
              {value?.isEditable === true ? (
                <div style={{ position: 'relative' }}>
                  <InputArea
                    onPressEnter={() => {
                      if (!showWordLoader) {
                        callVocAI();
                      }
                    }}
                    onChange={(d) => {
                      handleAddVocData('word', d.target.value.trimStart());
                    }}
                    placeholder="word"
                    autoSize
                    autoFocus
                    style={{
                      backgroundColor: 'transparent',
                      borderColor: 'transparent',
                      color: 'white',
                      fontWeight: 200,
                    }}
                  />
                  <div style={{ position: 'absolute', top: 6, right: 4 }}>
                    {showWordLoader ? (
                      <Loading size={17} />
                    ) : (
                      <EnterOutlined
                        disabled={showWordLoader}
                        onClick={() => {
                          if (!showWordLoader) {
                            // callVocAI();
                          }
                        }}
                        style={{ fontSize: '25px' }}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <>
                  <InputArea
                    disabled={
                      value?.created_by === 'owe_admin' ||
                      currentUser?.role === 'student' ||
                      value?.created_by === 'teacher'
                    }
                    value={get(data, 'word', '') + `${roleDisplay}`}
                    onChange={(d) =>
                      editDataPropertyStd(value.id, d.target.value.trimStart(), 'word')
                    }
                    placeholder="word"
                    autoSize
                    style={{
                      width: 150,
                      backgroundColor: 'transparent',
                      borderColor: 'transparent',
                      color: 'white',
                      fontWeight: 200,
                    }}
                  />
                </>
              )}
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'english_translation', '')}
                onChange={(d) =>
                  editDataPropertyStd(value.id, d.target.value.trimStart(), 'english_translation')
                }
                autoSize
                style={{
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'definition', '')}
                onChange={(d) =>
                  editDataPropertyStd(value.id, d.target.value.trimStart(), 'definition')
                }
                autoSize
                style={{
                  width: 200,
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'synonyms', '')}
                onChange={(d) =>
                  editDataPropertyStd(value.id, d.target.value.trimStart(), 'synonyms')
                }
                autoSize
                style={{
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'antonyms', '')}
                onChange={(d) =>
                  editDataPropertyStd(value.id, d.target.value.trimStart(), 'antonyms')
                }
                autoSize
                style={{
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>
            <td>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, 'sentence', '')}
                onChange={(d) =>
                  editDataPropertyStd(value.id, d.target.value.trimStart(), 'sentence')
                }
                autoSize
                style={{
                  width: 200,
                  backgroundColor: 'transparent',
                  borderColor: 'transparent',
                  color: 'white',
                  fontWeight: 200,
                  padding: 0,
                }}
              />
            </td>
            <td style={{ textAlign: 'center' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {data?.word && (
                  <Delete
                    style={{ fontSize: 20 }}
                    onClick={() => {
                      setDeleteModal(true);
                      setDeleteVocab(value);
                    }}
                  />
                )}
              </div>
            </td>
          </tr>
        );
      })}

      <tr className="vocabulHeadTr">
        <td>
          <IconButton onClick={addNewItem}>
            <Add style={{ fontSize: '18px' }} />
          </IconButton>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </StyledTable>
  );
};

export default SpanishVocabTab;
const ActionText = styled.p`
  font-size: 14px;
  color: white;
  font-weight: 500;
`;

const ModalContent = styled.div`
  left: 50%;
  max-width: 100vw;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  transform: translate(-50%, -50%);
  top: 50%;
  @media (max-width: 1366px) {
    width: 90vw;
  }

  @media (max-width: 500px) {
    max-height: 560px;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  overflow-y: auto;
  max-height: 550px;
  border-collapse: collapse;
  td {
    border: 0.5px solid #fff;
  }
  th {
    border: 0.5px solid #fff;
  }
`;

const StyledHeader = styled.tr`
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
`;
const StyledTh = styled.th`
  background: #5d4187;
  color: #ffffff;
`;
